<template>
  <div class="c-number-input">
    <input type="number" ref="input" :value="value" @input="updateValue($event.target.value)" :placeholder="placeholder"/>
    <span class="close" v-show="value.length > 0"
          @click="cleanInput"></span>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default{
    name: 'c-number-input',
    props: {
      value: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        nowInput: ''
      }
    },
    components: {},
    created () {},
    mounted () {},
    beforeDestroy () {},
    methods: {
      updateValue (value) {
        if (value.length > 0) {
          if (/^[0-9]+$/g.test(value)) {
            this.$emit('input', value)
          }
        } else {
          if (this.value.length === 1) {
            this.$refs.input.value = ''
            this.cleanInput()
          } else {
            this.$refs.input.value = this.value
          }
        }
      },
      cleanInput () {
        this.$emit('input', '')
      }
    },
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?4da69336